module.exports = __webpack_public_path__ + "static/media/icomoon.d0e676d8.ttf";